import Logger from '../../../common/logger';

const Messages = [
    {
        request: 'cmd_start',
        response: {
            messages: [
                {
                    type: 'ctrl_text',
                    value:
                        'Wybierz rodzaj & usługi której ma dotyczyć zgłoszenie awarii.'
                },
                {
                    type: 'ctrl_buttons',
                    value: [
                        {
                            text: 'Telefon Stacjonarny',
                            id: '1'
                        },
                        {
                            text: 'Neostrada',
                            id: '2'
                        },
                        {
                            text: 'Telewizja',
                            id: '3'
                        }
                    ]
                }
            ]
        }
    },
    {
        request: 'rslt_buttons',
        response: {
            messages: [
                {
                    type: 'ctrl_text',
                    value:
                        'Wybierz rodzaj & usługi której ma dotyczyć zgłoszenie awarii.'
                },
                {
                    type: 'ctrl_radiobutton_inputs',
                    value: [
                        {
                            text: 'Numer Neostrady',
                            type: 'neo',
                            id: '1'
                        },
                        {
                            text: 'Numer Telefonu Stacjonarnego',
                            type: 'phone',
                            id: '2'
                        }
                    ]
                }
            ]
        }
    },
    {
        request: 'rslt_radiobutton_inputs',
        response: {
            messages: [
                {
                    type: 'ctrl_text',
                    value: 'Podaj PIN'
                },
                {
                    type: 'ctrl_inputs',
                    value: [
                        {
                            text: 'PIN',
                            type: 'pin3',
                            id: '1'
                        }
                    ]
                }
            ]
        }
    },
    {
        request: 'rslt_inputs',
        response: {
            messages: [
                {
                    type: 'ctrl_text',
                    value:
                        'Wprowadzany numer został przesłany do diagnostyki. Proszę czekać na odpowiedź. Może to potrwać do 60 sekund'
                },
                {
                    type: 'cmd_refresh',
                    value: 3
                }
            ]
        }
    },
    {
        request: 'rslt_refresh',
        response: {
            messages: [
                {
                    type: 'ctrl_text',
                    value: 'Koniec...'
                },
                {
                    type: 'cmd_transfer',
                    value: ''
                }
            ]
        }
    }
];

const getMessage = request => {
    let response = {
        messages: [
            {
                type: 'ctrl_text',
                value: 'Nie znaleziono odpowiedzi'
            }
        ]
    };

    const message = Messages.find(m => m.request === request);
    if (message) {
        response = message.response;
    }

    return response;
};

const BotMockAPI = {
    getResponse: ({ request, callbacks }) => {
        Logger.log(
            'BotMockAPI.getResponse: request=' + JSON.stringify(request)
        );

        let index = request.index;

        if (index) {
            index = index + 1;
        }

        let response = {};

        if (request.messages.length > 0) {
            request.messages.forEach(m => {
                response = getMessage(m.type);
            });
        }

        response.engagementID = request.engagementID;
        response.index = index;

        Logger.log(
            'BotMockAPI.getResponse: response=' + JSON.stringify(response)
        );

        callbacks.success(response);
    }
};

export default BotMockAPI;
